import { initThread } from './_chatWidget.js';
import { animations } from './_animations.js';

document.addEventListener('DOMContentLoaded', () => {
    const messageContainer = document.getElementById('messageContainer');
    const output = document.getElementById('output');
    const chartCanvas = document.getElementById('chartCanvas');

    animations();

    // Initialize chat with suggested messages
    initThread(null);
});